import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { useDispatch } from 'react-redux';
import { oddFormatter } from 'Utils/decimalFormatter';
import {
  removeHorseFromCombinedBetSlip,
  setBetslipToast,
  resetBetSlipToast,
  addHorseToCombinedBetSlip
} from 'Store/actions/horseRacing/betSlipActions';

const CombinedHorseRow = ({ item }) => {
  const dispatch = useDispatch();

  const onItemDelete = () => {
    const { horse, hippodrome, bet, leg } = item;
    dispatch(removeHorseFromCombinedBetSlip(horse));
    dispatch(setBetslipToast(
      { justify: true,
        show: true,
        content: `<p>Kuponundaki <span>${horse?.uniqId ? `${horse?.horseNo}.${horse?.name}` : `${horse?.propositionInfo?.horseNumbers}.${horse?.propositionInfo?.horseNames}`}  - ${hippodrome?.name?.length > 14 ? hippodrome.name.substring(0, 14) + '...' : hippodrome?.name}</span> bahsi silindi</p>`, buttonText: 'Geri Al', icon: null, onButtonClick: () => {
          dispatch(addHorseToCombinedBetSlip(horse, hippodrome, bet, leg));
          dispatch(resetBetSlipToast());
        } }) );
  };


  return (
    <div className="combined-horse-row">
      <div className="leg-bet-info">
        <div className="leg-info"><Icon className="game-row__horse-icon"
          iconName="svgBetslipHorse"/> <span> { item?.hippodrome?.name }</span>
          ({ `${item?.leg?.legNo}.Koşu ${item?.leg?.startTime}` })
        </div>
        <div className="bet-odd-info">
          { item?.bet?.description }
          <span>Oran: { oddFormatter(item.horse?.propositionInfo) }</span>
        </div>
      </div>
      <div className="horses">
        <div className="horse-list">
          { item?.horse?.uniqId ? <div className="horse-item">
            <div className="horse-no">{ item?.horse?.horseNo }</div>
            <div className="horse-name"><span>{ item?.horse?.name }</span>
            </div>
          </div> : item.horse?.propositionInfo?.horseNumbers?.split('-').map((horseNo, index) => <div
            className="horse-item"
            key={ horseNo }>
            <div className="horse-no">{ horseNo }</div>
            <div className="horse-name"><span>{ item.horse?.propositionInfo?.horseNames?.split('-')[index].trim() }</span>
              { item?.bet?.isOrdered ? `${index + 1}. At` : 'İlk\n'
                + '              2’ye\n'
                + '              Girecek At' }
            </div>
          </div>) }
        </div>
        <div className="remove-area">
          <div onClick={ onItemDelete } className="trash-button">
            <Icon iconName="svgTrash"/>
          </div>
        </div>
      </div>
    </div>
  );
};

CombinedHorseRow.propTypes = {
  item: PropTypes.object
};

export default CombinedHorseRow;
